export const zipDownloadProxy = (
	fileId: string,
	name: string = 'download.zip',
) => {
	return `/api/download-file/${fileId}/${encodeURIComponent(name)}`
}
